import typeToReducer from "type-to-reducer";

import { SEARCH_DATA_LOADED } from "./types";

export const preApprovalsSearchReducer = typeToReducer(
  {
    [SEARCH_DATA_LOADED]: (state, action) => ({
      ...state,
      searchData: action.payload,
    }),
  },
  {
    homepageSearchTerm: "",
    searchData: [],
  },
);
